import Button from 'react-bootstrap/Button';
import { formButtonStyle } from '../../styles';
import { handleOptionSelect } from '../../functions';

export default function BuyRealEstate5({ setUserAnswers, navigate, location }) {
    return (
        <>
            <h2>Are you currently working with a real estate agent?</h2>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "WorkingWithAgent", "Yes")
                }
            >
                Yes
            </Button>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "WorkingWithAgent", "No")
                }
            >
                No
            </Button>
        </> 
    );
}